import AppApi from '@app/api/index';

export interface IntegrationDto {
  id: number;
  name: string;
  description?: string;
  isEnabled: boolean;
  createdAt?: string;
}

export interface CreateIntegrationDto {
  name: string;
  description?: string;
}

export default class IntegrationsApi {
  constructor(private readonly api: AppApi) {}

  getList(): Promise<IntegrationDto[]> {
    return this.api.client.get<IntegrationDto[]>('/integrations').then((r: unknown) => r as IntegrationDto[]);
  }

  create(dto: CreateIntegrationDto): Promise<IntegrationDto> {
    return this.api.client.post<CreateIntegrationDto, IntegrationDto>('/integrations', dto).then((r: unknown) => r as IntegrationDto);
  }

  update(id: number, dto: Partial<CreateIntegrationDto> & { isEnabled?: boolean }): Promise<IntegrationDto> {
    return this.api.client.patch<typeof dto, IntegrationDto>(`/integrations/${id}`, dto).then((r: unknown) => r as IntegrationDto);
  }

  delete(id: number): Promise<void> {
    return this.api.client.delete<null, void>(`/integrations/${id}`);
  }
}
